import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
// import { GoogleLogin } from 'react-google-login';
import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { gapi } from 'gapi-script';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import Regex from 'services/utils/regex/Regex';
import Loader from 'components/sales/Loader/loader';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import './login.css';
import SSOLogin from './SSOLogin';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';

const LoginSso = ({ tryGoogleAuthorisedUserLogin,history,login_data = [] }) => {
  const [userId, setUserId] = useState('');
  const [isError, setIserror] = useState('');
  const [roleId,setRoleId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  //const userIdRef = useRef(null);

  // useEffect(() => {
  //   userIdRef.current.focus();
  // }, [userIdRef]);

  // useEffect(() => {
  //   localStorage.clear();
  // }, []);

  useEffect(() => {
    var isWebview = true;
    // CHECKOUT
    // console.log(attCheckInSite); return false;
    // if(localStorage.getItem('isWebview')){
    //   isWebview = localStorage.getItem('isWebview');
    // }
    // console.log(isWebview); 
    if(isWebview){
      const RNWebView =  window["ReactNativeWebView"];
      console.log(RNWebView);
      console.log("RNWebView");
      if (RNWebView) {
          const contentStr = {
              event: "LOGOUT",
              data: null,
              os: "ANDROID",
          };
      
          RNWebView.postMessage(JSON.stringify(contentStr));
          localStorage.clear();
          sessionStorage.clear();
          setTimeout(() => {
          localStorage.clear();
          sessionStorage.clear();
          window.location.reload();
          }, 100);
      }
    }
  }, []);

  const handleSubmit = async (evt) => {
    // evt.preventDefault();
    // if (Regex.email.test(userId)) {
    //   setIserror('');
    //   setIsLoading(true);
    //   const res = await generateOtp(userId);
    //   setIsLoading(false);
    //   if (res === true) {
    //     history.push({
    //       pathname: '/login-otp',
    //       state: { otp: otp, email: userId },
    //     });
    //   }
    // } else {
    //   if (userId === '') {
    //     setIserror(localization.mandatoryField);
    //   } else setIserror(localization.loginErrorMg);
    // }
  };

  // const data = {
  //   'google_token': 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjI3NDA1MmEyYjY0NDg3NDU3NjRlNzJjMzU5MDk3MWQ5MGNmYjU4NWEiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJuYmYiOjE2NzU3NjYxMDksImF1ZCI6IjU2Mjc1NTk2NzQ2Ny05aXZjOXZwNm44YTMzdTByMWRrbmJwNXBhdGJmZXM5OC5hcHBzLmdvb2dsZXVzZXJjb250ZW50LmNvbSIsInN1YiI6IjEwNjc3NTk2Njc5NTcwNzUxNTk0MCIsImhkIjoibXlwYXJrcGx1cy5jb20iLCJlbWFpbCI6Imt1c2hhbC5rdW1hckBteXBhcmtwbHVzLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJhenAiOiI1NjI3NTU5Njc0NjctOWl2Yzl2cDZuOGEzM3UwcjFka25icDVwYXRiZmVzOTguYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJuYW1lIjoiS3VzaGFsIEt1bWFyIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FFZEZUcDRsbWMzUUk4a0NTWURUWVREMWI0WkxhdHRIN0V6cmh1ZHBRNC0wPXM5Ni1jIiwiZ2l2ZW5fbmFtZSI6Ikt1c2hhbCIsImZhbWlseV9uYW1lIjoiS3VtYXIiLCJpYXQiOjE2NzU3NjY0MDksImV4cCI6MTY3NTc3MDAwOSwianRpIjoiYjg3NjZmZDRhOTJhZmViZmJkMTdlOWVlYTc1NTA3MjI4YmM3OGM1MiJ9.LdVcVs7pvpg7XMNUHegXYzg2-XShNtoGIUY3TxTA4BrYR-e2trMoVaZPIIOHHnbte-EQ2Gh4W18fqkECKVHKBptE5j3BWDTWt1_j0VbBm_Bjtt0D-yc0-JwqQqcHsfCPIITZfMgxQVXjHHODtAz4RTKb_c-pe7UY_5O5h2eIA9G9RNI6TJBUGPNMgJpn6CaqnN4O5KLjiD78g1QjJqFJzjYvOdENA9niPaRTvX-CEhbuen1u-TGcBlGTs479HwpN5oG7xVetluzHndtHkNXXSzvuYPAre6R03GUl7XXYMxexqI2lSnZSSNyEzk2jui2CuM5xvx5TlIZyx56db6vWcg'
  // }

  const handleGoogleAuthorisedUser = async (data) => {
    if(data) {
      setIsLoading(true);
      const response = await tryGoogleAuthorisedUserLogin(data,roleId);
      setIsLoading(false);
      if (response?.status === true) {
        window.scrollTo(0, 0);
        console.log(localStorage.getItem('authenticated'))
        setTimeout(() => {
          console.log('session start');
        }, 1000);
        window.location.href="/dashboard/pm-dashboard";
      }
    }
  }

  // const clientId = '1088736098243-1249os37p8159hrbq7absbfjok307vfh.apps.googleusercontent.com'; // stage
  const clientId = '562755967467-9ivc9vp6n8a33u0r1dknbp5patbfes98.apps.googleusercontent.com';
  const onSuccess = (codeResponse) => {
    console.log('success:', codeResponse);
    var data = {
      'google_token': codeResponse.credential
    }
    if(data) {
      // googleLogin();
      handleGoogleAuthorisedUser(data); 
    }
  };
  const onFailure = (err) => {
    console.log('failed:', err);
    toast.error('Authentication Failed...');
  };

  

// const googleLogin = useGoogleLogin({
//   flow: 'auth-code',
//   onSuccess: async (codeResponse) => {
//       console.log(codeResponse);
//       // const tokens = await axios.post(
//       //     'http://localhost:3001/auth/google', {
//       //         code: ,
//       //     });

//       // console.log(tokens);
//   },
//   onError: errorResponse => console.log(errorResponse),
// });

  useEffect(() => {
    if(gapi.client !== undefined){
    const initClient = () => {
          gapi.client.init({
          clientId: clientId,
          scope: ''
        });
     };
     gapi.load('client:auth2', initClient);       
    }
  },[]);

  return (
    
    <div className="login-box">
      <div className="login-logo">
      {/* <img src={Images?.LogoWhite} alt="" style={{"width" : "18%"}}/> */}
      <img src={Images?.Logo} alt="" style={{"width" : "18%"}}/>
        <span>{localization.fusion}</span>
      </div>
      <div className="login-container">
        <Loader isLoading={isLoading} />
        <div className="login-fieldset">
          <h4>{localization.loginToAccount}</h4>
          <form onSubmit={handleSubmit}>
            {/* <LabelInput
              ref={userIdRef}
              className={`${userId.length ? '' : 'empty'}`}
              inputValue={userId}
              handleChange={(e) => setUserId(e.target.value.trim())}
              type="text"
              label={localization.emailIdNo}
              errorMsg={isError}
            /> */}
            {login_data.length !== 0 ? 
              <DropDownInput
              disabled={login_data.length === 0}
              label={`Select Role`}
              data={login_data}
              getIdValue={(val) => {
                setRoleId( val.id)
              }}
            />
              : ''}
            <div className="form-group form-stat">
              
              <b className="New-form">
              <GoogleOAuthProvider clientId="562755967467-9ivc9vp6n8a33u0r1dknbp5patbfes98.apps.googleusercontent.com">
              {/* <GoogleLogin
                  clientId={clientId}
                  buttonText="Log in with Google"
                  onSuccess={onSuccess}
                  onFailure={onFailure}
                  cookiePolicy={'single_host_origin'}
                  isSignedIn={true}
              /> */}
              <SSOLogin 
              tryGoogleAuthorisedUserLogin={tryGoogleAuthorisedUserLogin}
              roleId={roleId}
              login_data={login_data}
              ></SSOLogin>
              </GoogleOAuthProvider>
              </b>
            </div>
          </form>
          {/* <b className='New-form'>
              <input type={`button`} value='Try Login' onClick={()=> handleGoogleAuthorisedUser(data)} />
          </b> */}
        </div>
      </div>
      <div className="copyright">
        <p>{localization.copyRight}</p>
      </div>
    </div>
  );
};

// LoginSso.propTypes = {
//   generateOtp: PropTypes.func.isRequired,
//   otp: PropTypes.oneOfType([
//     PropTypes.number,
//     PropTypes.string,
//     PropTypes.bool,
//   ]),
//   history: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
// };

export default LoginSso;